export default __webpack_public_path__ + "static/media/image-1.a6eee173.png";